// extracted by mini-css-extract-plugin
export default {"title":"ContentTitle_title__J5ZeG"};